import { c as _c } from "react/compiler-runtime";
import { type GetActivityItem } from '../ActivityItem';
import { ggst_metablob_v1 } from '../../../convex/metablobs/ggst/v1';
import { GGSTPortrait } from './GGSTPortrait';
export const GGSTActivityFace = t0 => {
  const $ = _c(32);
  const {
    activity,
    size: t1,
    variant: t2
  } = t0;
  const size = t1 === undefined ? 96 : t1;
  const variant = t2 === undefined ? "normal" : t2;
  let t3;
  if ($[0] !== activity.metablob) {
    t3 = activity.metablob !== undefined ? JSON.parse(activity.metablob) : null;
    $[0] = activity.metablob;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const raw = t3;
  if (!raw || raw.metablobVersion !== "ggst_metablob_v1") {
    return null;
  }
  const m = raw as ggst_metablob_v1;
  console.log(raw);
  const p1Won = m.winner === "p1";
  const p2Won = m.winner === "p2";
  const winBorder = _temp;
  if (variant === "slim") {
    const t4 = m.p1Character;
    const t5 = winBorder(p1Won);
    let t6;
    if ($[2] !== m.p1Character || $[3] !== size || $[4] !== t5) {
      t6 = <GGSTPortrait character={t4} size={size} className={t5} />;
      $[2] = m.p1Character;
      $[3] = size;
      $[4] = t5;
      $[5] = t6;
    } else {
      t6 = $[5];
    }
    let t7;
    if ($[6] !== m.p1RoundWins || $[7] !== m.p2RoundWins) {
      t7 = <div className="text-xs font-mono">{m.p1RoundWins}-{m.p2RoundWins}</div>;
      $[6] = m.p1RoundWins;
      $[7] = m.p2RoundWins;
      $[8] = t7;
    } else {
      t7 = $[8];
    }
    const t8 = m.p2Character;
    const t9 = winBorder(p2Won);
    let t10;
    if ($[9] !== m.p2Character || $[10] !== size || $[11] !== t9) {
      t10 = <GGSTPortrait character={t8} size={size} className={t9} />;
      $[9] = m.p2Character;
      $[10] = size;
      $[11] = t9;
      $[12] = t10;
    } else {
      t10 = $[12];
    }
    let t11;
    if ($[13] !== t10 || $[14] !== t6 || $[15] !== t7) {
      t11 = <div className="flex flex-row gap-1 items-center">{t6}{t7}{t10}</div>;
      $[13] = t10;
      $[14] = t6;
      $[15] = t7;
      $[16] = t11;
    } else {
      t11 = $[16];
    }
    return t11;
  }
  const t4 = m.p1Character;
  const t5 = winBorder(p1Won);
  let t6;
  if ($[17] !== m.p1Character || $[18] !== size || $[19] !== t5) {
    t6 = <GGSTPortrait character={t4} size={size} className={t5} />;
    $[17] = m.p1Character;
    $[18] = size;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== m.p1RoundWins || $[22] !== m.p2RoundWins) {
    t7 = <div className="text-lg font-mono">{m.p1RoundWins} - {m.p2RoundWins}</div>;
    $[21] = m.p1RoundWins;
    $[22] = m.p2RoundWins;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  const t8 = m.p2Character;
  const t9 = winBorder(p2Won);
  let t10;
  if ($[24] !== m.p2Character || $[25] !== size || $[26] !== t9) {
    t10 = <GGSTPortrait character={t8} size={size} className={t9} />;
    $[24] = m.p2Character;
    $[25] = size;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t6 || $[30] !== t7) {
    t11 = <div className="flex flex-row gap-2 items-center">{t6}{t7}{t10}</div>;
    $[28] = t10;
    $[29] = t6;
    $[30] = t7;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
};
function _temp(won) {
  return won ? "border-2 border-green-400" : "border-2 border-transparent";
}